var render = function render(){var _vm=this,_c=_vm._self._c;return _c('timeoff-cutoff',{attrs:{"teamId":_vm.teamId,"pageKey":_vm.pageKeys.timeoff_company_approver}})
}
var staticRenderFns = []

export { render, staticRenderFns }